module.exports = __webpack_public_path__ + "static/media/process.76d7e2ec.svg";